/**
 * The game → music feed (audio-direction §4.3: "state machine fed at 4 Hz from game state"): accumulates frame
 * time, tracks how long ago the player was hit and fired, and every 1/feedHz seconds fills the intensity input
 * (nearest living raider, engagement) for the music's state machine. Pure and allocation-free.
 */
import type { IntensityInput } from './music/intensity'
import type { CombatSummary } from './router'

export interface MusicFeedState {
  /** Seconds accumulated towards the next feed. */
  acc: number
  readonly input: IntensityInput
}

export function createMusicFeed(): MusicFeedState {
  return { acc: 0, input: { nearestHostile: Infinity, sinceHit: Infinity, sinceFired: Infinity } }
}

/**
 * Advances by `dt` with this frame's combat summary and the distance to the nearest living raider. Returns the
 * seconds since the last feed when one is due (then `state.input` is current), else 0.
 */
export function stepMusicFeed(state: MusicFeedState, dt: number, summary: CombatSummary, nearestHostile: number, feedHz: number): number {
  const i = state.input
  i.sinceHit = summary.playerHit > 0 ? 0 : i.sinceHit + dt
  i.sinceFired = summary.playerFired > 0 ? 0 : i.sinceFired + dt
  i.nearestHostile = nearestHostile
  state.acc += dt
  const period = 1 / feedHz
  if (state.acc < period) return 0
  const elapsed = state.acc
  state.acc = 0
  return elapsed
}
